import { DataManager } from "../../Managers/DataManager";

export class FireBirdHelp {
    private _actualHelpPage = -1;

    constructor() {}

    initialize(): void {}

    cycle(): void {
        this._actualHelpPage++;
        let i: number;

        var elements = document.getElementsByClassName("helpPage");
        for (i = 0; i < elements.length; i++) {
            (elements[i] as HTMLDivElement).style.display = "none";
        }

        var pagingElements = document.getElementsByClassName("pageNumber");
        for (i = 0; i < pagingElements.length; i++) {
            (pagingElements[i] as HTMLDivElement).classList.remove("_active");
        }

        let element = document.getElementById("help");
        if (element != null) {
            element.style.display = "block";
        }

        if (elements[this._actualHelpPage] != null) {
            (elements[this._actualHelpPage] as HTMLDivElement).style.display = "block";
            if (pagingElements[this._actualHelpPage] != null) {
                (pagingElements[this._actualHelpPage] as HTMLDivElement).classList.add("_active");
            }
        } else {
            this.reset(true);
        }
    }

    reset(force: boolean = false): void {
        this._actualHelpPage = -1;
        let element = document.getElementById("help");
        if (element != null) {
            element.style.display = "none";
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/FireBird/FireBirdHelp.ts
 **/